import axiosInstance from '../../config/axios';
import type { APIResp } from '../../types/APIService';

export type Settings = {
  priceFullctr: number
  priceCoping: number
  price3D: number
  priceModels: number
};

const API_ENDPOINT = 'settings';
export async function getSettings(): Promise<Settings> {
  try {
    const res = await axiosInstance.get<APIResp<{ settings: Settings }>>(API_ENDPOINT);
    const settings = res.data.data.settings as Partial<Settings>;
    return {
      priceFullctr: settings.priceFullctr ?? 0,
      priceCoping: settings.priceCoping ?? 0,
      price3D: settings.price3D ?? 0,
      priceModels: settings.priceModels ?? 0,
    };
  }
  catch {
    return {
      priceFullctr: 0,
      priceCoping: 0,
      price3D: 0,
      priceModels: 0,
    };
  }
}

export async function updateSettings(settings: Settings): Promise<boolean> {
  try {
    await axiosInstance.put<APIResp<boolean>>(API_ENDPOINT, { settings });
    return true;
  }
  catch {
    return false;
  }
}
